import { SkillsTabContent as SkillsTabContentFromPackage } from "@cpj-ai/panel-npm-package";
import { useGetUserSkillsQuery } from "@graphql/generated";
import { useParams } from "react-router-dom";

interface ISkillsTabContent {
  handleNextTab: () => void;
}

const SkillsTabContent = ({ handleNextTab }: ISkillsTabContent) => {
  const params = useParams();
  const {
    data: userSkills,
    loading: useSkillsLoading,
    refetch: refetchUserSkills,
  } = useGetUserSkillsQuery({
    variables: {
      id: params.id,
    },
  });

  return (
    <SkillsTabContentFromPackage
      handleNextTab={handleNextTab}
      userSkills={{
        rawSkills: userSkills?.admin?.jobSeekers?.edges[0]?.node?.profile?.rawSkills,
        skills: userSkills?.admin?.jobSeekers?.edges[0]?.node?.profile?.skills,
      }}
      useSkillsLoading={useSkillsLoading}
      refetchUserSkills={refetchUserSkills}
    />
  );
};

export default SkillsTabContent;
